import controller from './compare-products.controller';
import template from './compare-products.view.html';

let CompareProductsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default CompareProductsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/compare-products/compare-products.component.js
 **/